import { useSelector } from 'react-redux';
import { BoardTypes } from '../interfaces';
import { getBaccaratMembers } from '../selectors';

export const useGameMembers = (type: BoardTypes) => useSelector(getBaccaratMembers(type));
